import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import media from 'themes/media';

const NavbarItem = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px ${(props) => props.theme.sizing.menuPadding};
  color: ${(props) =>
    props.active
      ? props.theme.colors.text.textColorDark
      : props.theme.colors.text.textColor};

  :hover {
    color: ${(props) => props.theme.colors.text.textColorDark};
  }

  @media (min-width: 1400px) and (max-height: 778px) {
    padding: 3px ${(props) => props.theme.sizing.menuPadding};
  }

  ${media.lessThan('tablet')`
    padding: 9px ${(props) => props.theme.sizing.menuPadding};
  `};

  @media (max-width: 375px) {
    padding: 7px ${(props) => props.theme.sizing.menuPadding};
  }

  @media (max-height: 740px) and (max-width: 1400px) {
    padding: 6px ${(props) => props.theme.sizing.menuPadding};
  }
`;
const NavbarIcon = styled.div`
  font-size: 18px;
  margin-right: 14px;
  width: 20px;
  display: flex;

  svg {
    fill: ${(props) => (props.active ? '#2D9CDB' : '#7E8EAA')};
  }
`;
const NavbarText = styled.span`
  font-size: 16px;
  font-weight: 500;
`;
const SwitchAccountTypeWrapper = styled.div`
  ${ifProp(
    'isTradingPage',
    css`
      @media (max-width: 1399px) and (min-width: 450px) {
        display: none;
      }
    `
  )}
`;

const SiteNavbarDivider = styled.div`
  margin: 16px ${(props) => props.theme.sizing.menuPadding};
  border-bottom: 1px solid
    ${(props) => props.theme.colors.background.borderColor};

  @media (max-height: 740px) and (min-width: 1400px) {
    margin: 6px ${(props) => props.theme.sizing.menuPadding};
  }
`;
const Navbar = styled.div`
  background: ${(props) => props.theme.colors.background.menuBodyColor};
  padding-top: 10px;
`;
const SwitchAccountHeading = styled.p`
  width: 90%;
  padding: 6px 30px;
  line-height: 1;
  font-weight: 400;
`;
const LanguageSwitcherContainer = styled.div`
  display: none;
  ${media.greaterThan('desktop')`
    display: block;
  `}
  padding: 24px 0 16px;
  margin-left: 30px;
  margin-right: 30px;
  border-top: 1px solid #e8ebf2;
`;

export const S = {
  NavbarItem,
  NavbarIcon,
  NavbarText,
  SwitchAccountTypeWrapper,
  SiteNavbarDivider,
  Navbar,
  SwitchAccountHeading,
  LanguageSwitcherContainer,
};
